import gql from 'graphql-tag'

export const UPDATE_USER = gql`
  mutation UpdateUser($id: Int!, $data: HeroUpdateInput!) {
    updateUser: updateHero(id: $id, data: $data) {
      id
      name
      products {
        id
        minQuantity
        material {
          id
          name
          cover {
            id
            url
          }
        }
      }
      locations {
        id
        lat
        lng
        radius
        address
      }
    }
  }
`

export const UPLOAD_AVATAR = gql`
  mutation UploadAvatar($file: Upload!) {
    uploadAvatar: uploadHeroAvatar(file: $file) {
      uid
    }
  }
`

export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword(
    $id: Int!
    $oldPassword: String!
    $newPassword: String!
  ) {
    updateUserPassword: updateHeroPassword(
      id: $id
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      id
      name
    }
  }
`

export const UPLOAD_DOCUMENT = gql`
  mutation UploadDocument($document: String!, $file: Upload!) {
    uploadDocument(document: $document, file: $file) {
      uid
      url
      name
      status
    }
  }
`

export const REMOVE_DOCUMENT = gql`
  mutation RemoveDocument($document: String!, $imageId: Int!) {
    removeDocument(document: $document, imageId: $imageId) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/User.js